module.exports = __webpack_public_path__ + "static/coldlight_walker-baaea0d457a2efe0a1ce9b9a5d838728.jpeg";